import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../components/Layout'
import Image from 'gatsby-image'
import { Helmet } from 'react-helmet'

import CTA from '../components/CTA'
import Header from '../components/Header'
import FAQs from '../components/FAQs'
import styled from 'styled-components'

const Content = styled.section`
  margin: 0 auto;
  padding: 50px 20%;

  &:nth-child(2n + 1) {
    background: #eaf8ff;
  }

  h2 {
    font-size: 2.3em;
  }
  h4 {
    font-weight: 500;
  }
  p {
    margin-bottom: 1em;
  }
`

const info = [
  {
    question: 'What do you mean by custom design?',
    answer: `We like to take the hassle out of custom design. So, we've gone against the grain and have created a dedicated and simple solution. Rather than forcing you to design anything on your own, we work with you and our design team to create a tailored or completely custom garment design. Colours, embroidery, patterning, logos, collar styles, etc. are all within our capabilities. We'll talk you through the whole process to ensure you love the end result.`
  },
  {
    question: 'What do I need to bring to my appointment?',
    answer: `Nothing. We'll come to a location that suits you to sit down and get some initial designs completed. You can take this back to your team, or other stakeholders for further refinements. We'll assist every step of the way to ensure you end up with something you love.`
  },
  {
    question: 'What does my initial design consultation cost?',
    answer: `The initial design consultation is completely free. There is no cost and no obligations. Just call or email us today and we'll arrange a time to meet and get your new sportswear designs underway.`
  },
  {
    question: 'Can I just pick an existing design?',
    answer: `Absolutely. If you see something you love, why bother reinventing the wheel. Just let us know what you like and we can build from that as a base, or just switch out the logo and colours.`
  },
  {
    question: 'What happens during my first consultation?',
    answer: `We will sit down you with and one of our specialist designers to understand exactly what you are after and create it right in front of you as we speak. We've found our live in-person editing sessions to be best, but we can happily work from a brief and send you the results when they are ready.`
  },
  {
    question: 'Can I choose custom fabric and embroidery?',
    answer: `You can customise every aspect of your garment. Let us know what you're after and we will work to make it a reality. We can advise and recommend different designs, styles and fabrics for each sport to help guide you in this process with our 20+ years of experience.`
  }
]

export default ({ data }) => (
  <Layout>
    <Helmet>
      <title>Custom Designs - Brisbane Sportswear - GFit Sportswear</title>
      <meta
        name="description"
        content="Still have questions? We've got the answers, have a read through our custom design FAQs to find exactly what your looking for about our unique design and manufacturing options."
      />
    </Helmet>
    <Header>
      <h1>Custom Designs</h1>
    </Header>
    <Content style={{ marginTop: 150 }}>
      <h2>Design Service &amp; Team</h2>
      <p>
        Here at GFIT we offer a unique art service, our artists will come and
        meet with a group of members or club committee and you can design and
        prepare your whole range in one appointment, all your colours, all your
        club logos and all sponsors logos are all added into a presentation for
        you to present at your club.
      </p>

      <p>
        GFIT is well known for its cutting edge designs, this has only been
        possible due to our team of talented artist who have a great ability to
        look outside the square, they start with a concept and turn the concept
        into a reality, they continue to work with you until you have the look
        that your team or club are trying to achieve.
      </p>
      <p>
        If you are looking for a visibly professional design to make you stand
        out above the crowd and to help increase your clubs identity and that of
        any brand sponsors associated with the club give the GFIT design team a
        call.{' '}
      </p>
      <Image
        style={{ width: '70%', margin: '50px auto 0', borderRadius: 8 }}
        fluid={data.design.childImageSharp.fluid}
      />
    </Content>
    <Content>
      <h2>Embroidery Service</h2>
      <p>
        Embroidery is one of the oldest decorating techniques, yet still it
        demands it’s place in the modern branding world. Our embroidery services
        offer a beautiful look and feel on fabric, we can offer the full range
        of thread colours which leaves your logo looking very sharp and eye
        catching.
      </p>
      <p>
        Essentially, this process consists of decorating fabric with a fine
        thread of material that is woven on top of or through the garment. It’s
        a long-lasting and durable customisation option that has been part of
        human history for hundreds of years, if not longer.
      </p>
      <p>
        This style of customisation gives your items a classic, refined look,
        and is sure to last through years of washes and everyday use. Unlike
        other branding options, its integration with the fabric itself lends it
        true strength and a long-lasting quality.
      </p>
      <p>
        The GFIT embroidery studio offers the very latest in technology and
        machinery, that gives us the ability to add your club or company logo to
        any fabric type including all caps and bags.
      </p>
      <p>
        We keep the process very simple, you send us your logo in any format and
        we will look after the rest, there are no hidden set up costs and all
        art work is completed at no cost to our clients, all our work comes with
        the GFIT quality assurance.
      </p>
      <Image
        style={{ width: '70%', margin: '50px auto 0', borderRadius: 8 }}
        fluid={data.embroidery.childImageSharp.fluid}
      />
    </Content>
    <Content>
      <h2>Custom Prints Made Easy</h2>

      <p>
        With our own state of the art screen printing facility GFIT use the
        latest technology to offer the best quality finish for their customers.
        GFIT provide their customers with visual solutions that enhance a
        brand’s message and helps grow your brands awareness. Having our own
        printing facility allows us to maintain the very best quality, service
        and turn-around time. The GFIT team can recommend the best printing
        finish for each individual job. For artwork requirements the GFIT art
        and design team will manage the process of making your image or logo
        into a ready to print file at no cost to our client.
      </p>
      <h4>Printing solutions for different materials</h4>
      <p>
        There is a great variety in the inks that you can use for each
        individual job, for example - metallic, flocking, expanding (puff),
        glitter, plastisol and water based inks, these printing inks can be used
        to work with a variety of materials, such as textiles, ceramics, wood,
        paper, glass, metal, and plastic. Overall, this is a very versatile
        printing technique and can accommodate a variety of our clients’
        different needs.
      </p>
      <h4>GFIT apparel screen printing service.</h4>
      <p>
        The GFIT print team can offer printed shirts for individuals, teams and
        businesses, we have the expertise to print a logo or artwork onto any
        sized garment. Our printing techniques make it remarkably easy to print
        virtually any image onto any fabric, this process delivers a high
        quality product tailored to each individual clients needs.
      </p>
      <Image
        style={{ width: '70%', margin: '50px auto 0', borderRadius: 8 }}
        fluid={data.screenPrint.childImageSharp.fluid}
      />
    </Content>
    <Content>
      <h2>The Process of Sublimated Sportswear</h2>
      <p>
        In the world of sports apparel, sublimated sportswear is by far the most
        popular print process used by sporting teams. If you are looking for
        cutting edge designs and colours sublimation is your best option. Here
        at GFIT all of our sublimated garments are manufactured in the latest
        carefully selected high performance sportswear fabrics on the market.
        Please refer our fabrics page.
      </p>

      <p>
        Here is an overview on how the sublimation process is completed from the
        day your order is placed.
      </p>
      <p>
        The first stop is our Art department, here the art work is drawn up
        across the order size range, that file is directly sent down to the
        printing rooms. The design is printed out onto transfer paper.
      </p>
      <p>
        Once all the prints are printed out on the transfer paper, the design
        needs to be transferred from the paper onto the fabric. This is done
        through a large heat press (as pictured below). The heat turns the ink
        into a gas which allows it to be sublimated into the fabric. Once the
        garment has cooled the design has now become part of the garment, no
        matter how many washes the design will always look like it does on day
        one, there is no chance the colours will run or peel off.
      </p>
      <p>
        With sublimation your options are limitless, you can turn any design
        concept into reality using the process.
      </p>
      <p>
        In conjunction with the GFIT design team and a GFIT fabric specialist
        you can create the most comfortable, best performing team wear available
        in todays market.
      </p>
      <Image
        style={{ width: '70%', margin: '50px auto 0', borderRadius: 8 }}
        fluid={data.sublimation.childImageSharp.fluid}
      />
    </Content>
    <Content>
      <h2>Delivery Process</h2>
      <p>
        Once your order is complete, we waste no time in getting it straight out
        to our clients, the day its finished is the day they leave our
        manufacturing facility.{' '}
      </p>
      <p>
        All our deliveries come via DHL Air Express to the GFIT office, they
        will then be delivered in person by a GFIT team member to your door that
        day.
      </p>
      <p>
        All deliveries can be tracked on the DHL Express website once you
        receive your shipping number.
      </p>
      <p>
        Time in transit is 3 days for offshore custom orders and 1 day for local
        express production.
      </p>
      <Image
        style={{ width: '70%', margin: '50px auto 0', borderRadius: 8 }}
        fluid={data.delivery.childImageSharp.fluid}
      />
    </Content>
    <Content>
      <h2>Express Order</h2>
      <p>
        While we work on a four week reliable delivery schedule on sublimated
        orders, we also understand that sometimes you need it yesterday, to help
        you here we can offer a Express option that is made locally in our
        Brisbane facility or we help with off the shelf options, we have access
        to many of the big wholesale suppliers and we can offer a massive range
        of solutions to your urgent order requirements.
      </p>
      <p>
        For further details on Express orders please make contact with our sales
        team at sales@gfitwear.com
      </p>
    </Content>
    <FAQs flushTop={true} faqs={info} title={'FAQs'} />
    <CTA
      title="Want to know more?"
      subtitle="Ask the experts."
      button="Contact Us"
    />
  </Layout>
)

export const query = graphql`
  query CustomDesignsQuery {
    sublimation: file(relativePath: { eq: "sublimation.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    screenPrint: file(relativePath: { eq: "screen-print.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    design: file(relativePath: { eq: "design.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    delivery: file(relativePath: { eq: "delivery.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    embroidery: file(relativePath: { eq: "embroidery.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
